/**
 *
 * GeoSearch
 *
 */

import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import SearchControl from 'components/SearchControl';
import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';
import { DAEMON } from 'utils/constants';
import makeSelectGeoSearch from './selectors';
import reducer from './reducer';
import saga from './saga';
import { geoSearch, geoSearchClear, geoSelect } from './actions';

/* eslint-disable react/prefer-stateless-function */
function GeoSearch(props) {
  return <SearchControl {...props} />;
}

GeoSearch.propTypes = {};

const mapStateToProps = createStructuredSelector({
  geosearch: makeSelectGeoSearch(),
});

function mapDispatchToProps(dispatch) {
  return {
    doSearch: search => dispatch(geoSearch(search)),
    clearSearch: search => dispatch(geoSearchClear(search)),
    selectResult: id => dispatch(geoSelect(id)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'geoSearch', reducer });
const withSaga = injectSaga({ key: 'geoSearch', saga, mode: DAEMON });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(GeoSearch);
